import React from "react"
import { Grid } from "@material-ui/core"

import useStyles from "@/components/ACExternalConversationPanel/Input/MediaPreview/styles"

import { Media } from "@/services/Media"

import MediaList from "@/components/ACExternalConversationPanel/Input/MediaPreview/MediaList"

type MediaPreviewProps = {
	medias: Media[]
	onRemove: (mediaIndex: number) => void
}

const MediaPreview: React.FC<MediaPreviewProps> = (props) => {
	const { medias, onRemove } = props

	const isThereAnyMedia = Boolean(medias.length)

	const classes = useStyles()

	return (
		<>
			{isThereAnyMedia && (
				<Grid
					container
					alignItems="center"
					justify="center"
				>
					<Grid
						container
						className={classes.mediaContainer}
					>
						<MediaList
							medias={medias}
							onRemove={onRemove}
						/>
					</Grid>
				</Grid>
			)}
		</>
	)
}

export default MediaPreview
